import axios from '@/plugins/axios'
import util from '@/services/util'
import constant from '@/services/constants'

import { XLSXWriter } from '@/services/xlsx'

const wristbandEndPoint = 'admin/wristband'

export default {
    namespaced: true,

    state: {
        wristbands: [],
        total: 0
    },

    getters: {
        getWristbandById: () => async id => {
            return await axios.get(`${wristbandEndPoint}/${id}`)
        }
    },

    mutations: {
        setWristbands (state, wristbands) {
            state.wristbands = wristbands
        },

        setWristbandTotal (state, total) {
            state.total = total
        }
    },

    actions: {
        async fetchWristbands ({ commit }, query) {
            if (query?.from && query?.to && query.from === query.to) {
                const oldDate = new Date(query.to)
                const newDate = new Date(oldDate.setDate(oldDate.getDate() + 1))
                query.to = `${newDate.getFullYear()}-${util.getTwoDigitNumber(newDate.getMonth() + 1)}-${newDate.getDate()}`
            }
            const response = await axios.get(util.buildUrlWithQuery(wristbandEndPoint, query))
            const { wristbands, total } = response
            commit('setWristbands', wristbands)
            commit('setWristbandTotal', total)
        },

        async getWristbandReport ({ state, getters }, query) {
            if (query?.from && query?.to && query.from === query.to) {
                const oldDate = new Date(query.to)
                const newDate = new Date(oldDate.setDate(oldDate.getDate() + 1))
                query.to = `${newDate.getFullYear()}-${util.getTwoDigitNumber(newDate.getMonth() + 1)}-${newDate.getDate()}`
            }
            const response = await axios.get(util.buildUrlWithQuery(wristbandEndPoint, query))
            const { wristbands } = response

            const wristbandWithTransactions = []

            for (let i = 0; i < wristbands.length; i++) {
                const wristband = wristbands[i]

                let wristbandWithTransaction = null
                try {
                    wristbandWithTransaction = await getters.getWristbandById(wristband.id)
                } catch {
                    continue
                }

                wristbandWithTransactions.push(wristbandWithTransaction)
            }

            const writter = new XLSXWriter({
                title: 'Wristband',
                subject: 'Report',
                author: state.username
            })

            writter.setHeaders(constant.report.WRISTBAND_HEADERS)

            wristbandWithTransactions.forEach(wristband => {
                const wristbandRows = [
                    wristband.GiftCardNo,
                    wristband.name,
                    util.getDDMMYYYYHHSSDateFormat(new Date(wristband.createdAt).getTime() + (60 * 420 * 1000))
                ]

                wristband.transactions.forEach(transaction => {
                    writter.addRow([
                        ...wristbandRows,
                        '100001',
                        util.getDDMMYYYYHHSSDateFormat(new Date(transaction.date).getTime() + (60 * 420 * 1000)),
                        transaction.name,
                        transaction.value
                    ])
                })
            })

            util.downloadBlob(
                writter.getXlsxBlob(),
                `AndamandaWristband_${util.getDDMMYYYYDateFormat(new Date())}.xlsx` ?? 'AndamandaWristband.xlsx'
            )
            return writter.getXlsxBlob()
        }
    }
}
